import styled, { css } from 'styled-components';

import Card from 'LegacyWeployDesignLanguage/Card';

import media from '../../../media';

export const BaseProfileCardContainer = styled.div`
  box-sizing: border-box;
  display: flex;

  & * {
    box-sizing: border-box;
  }

  ${media.tablet`
    flex-basis: 33.3%;
    padding: ${props => props.theme.space.half} ${props => props.theme.space.half};
  `}
`;

export const PROFILE_CARD_BORDER = '12px';
export const DISABLED_BORDER_COLOUR = 'rgba(0, 0, 0, 0.12)';

export const BaseProfileCard = styled(Card)`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  border: ${PROFILE_CARD_BORDER} solid ${props => props.theme.colors.white};
  margin: 0;
  overflow: hidden;

  ${props => props.disabled && css`
    border: ${PROFILE_CARD_BORDER} solid ${DISABLED_BORDER_COLOUR};
  `};
`;

export default {
  BaseProfileCard,
  BaseProfileCardContainer,
};
